import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-term-conditions',
  standalone: true,
  imports: [],
  templateUrl: './term-conditions.component.html',
  styleUrl: './term-conditions.component.css',
})
export class TermConditionsComponent {
  constructor(private router: Router) {
    // do nothing
  }
  acceptTerms() {
    this.router.navigate(['/']);
  }
}
